import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { AuthService } from '@core/auth';
import { isInterceptorDisabled } from './is-interceptor-disabled';

export const DISABLE_AUTH_TOKEN_INTERCEPTOR = new HttpContextToken(() => false);

export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  if (isInterceptorDisabled(request.context, DISABLE_AUTH_TOKEN_INTERCEPTOR)) {
    return next(request);
  }

  const addAuthToken = (request: HttpRequest<any>): HttpRequest<any> => {
    const authToken = authService.getAccessToken();
    const assetsReq = request.url.includes('assets');

    return authToken && !assetsReq
      ? request.clone({ setHeaders: { Authorization: `Bearer ${ authToken }` } })
      : request;
  };

  return next(addAuthToken(request));
};
